/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ScheduleExceptionRequest,
} from '../models/index';
import {
    ScheduleExceptionRequestFromJSON,
    ScheduleExceptionRequestToJSON,
} from '../models/index';

export interface ApplyExceptionRequest {
    scheduleId: string;
    scheduleExceptionRequest: ScheduleExceptionRequest;
    sessionId?: string;
}

export interface GetBlocksRequest {
    scheduleId: string;
    startTime: string;
    endTime: string;
    page?: number;
    pageSize?: number;
    sessionId?: string;
}

export interface GetCurrentBlockRequest {
    scheduleId: string;
    sessionId?: string;
}

export interface GetNextBlockRequest {
    scheduleId: string;
    sessionId?: string;
}

/**
 * ScheduleBlocksApi - interface
 * 
 * @export
 * @interface ScheduleBlocksApiInterface
 */
export interface ScheduleBlocksApiInterface {
    /**
     * Applies an exception to schedule blocks (cancel, modify, extend, etc.)
     * @summary Apply schedule exception
     * @param {string} scheduleId Schedule ID
     * @param {ScheduleExceptionRequest} scheduleExceptionRequest 
     * @param {string} [sessionId] Session ID for authorization
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ScheduleBlocksApiInterface
     */
    applyExceptionRaw(requestParameters: ApplyExceptionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>>;

    /**
     * Applies an exception to schedule blocks (cancel, modify, extend, etc.)
     * Apply schedule exception
     */
    applyException(requestParameters: ApplyExceptionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }>;

    /**
     * Retrieves schedule blocks for a time range
     * @summary Get schedule blocks
     * @param {string} scheduleId Schedule ID
     * @param {string} startTime Start time (ISO-8601)
     * @param {string} endTime End time (ISO-8601)
     * @param {number} [page] Page number (0-indexed)
     * @param {number} [pageSize] Page size
     * @param {string} [sessionId] Session ID for authorization
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ScheduleBlocksApiInterface
     */
    getBlocksRaw(requestParameters: GetBlocksRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>>;

    /**
     * Retrieves schedule blocks for a time range
     * Get schedule blocks
     */
    getBlocks(requestParameters: GetBlocksRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }>;

    /**
     * Gets the currently active block for a schedule
     * @summary Get current block
     * @param {string} scheduleId Schedule ID
     * @param {string} [sessionId] Session ID for authorization
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ScheduleBlocksApiInterface
     */
    getCurrentBlockRaw(requestParameters: GetCurrentBlockRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>>;

    /**
     * Gets the currently active block for a schedule
     * Get current block
     */
    getCurrentBlock(requestParameters: GetCurrentBlockRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }>;

    /**
     * Gets the next upcoming block for a schedule
     * @summary Get next block
     * @param {string} scheduleId Schedule ID
     * @param {string} [sessionId] Session ID for authorization
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ScheduleBlocksApiInterface
     */
    getNextBlockRaw(requestParameters: GetNextBlockRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>>;

    /**
     * Gets the next upcoming block for a schedule
     * Get next block
     */
    getNextBlock(requestParameters: GetNextBlockRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }>;

}

/**
 * 
 */
export class ScheduleBlocksApi extends runtime.BaseAPI implements ScheduleBlocksApiInterface {

    /**
     * Applies an exception to schedule blocks (cancel, modify, extend, etc.)
     * Apply schedule exception
     */
    async applyExceptionRaw(requestParameters: ApplyExceptionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>> {
        if (requestParameters['scheduleId'] == null) {
            throw new runtime.RequiredError(
                'scheduleId',
                'Required parameter "scheduleId" was null or undefined when calling applyException().'
            );
        }

        if (requestParameters['scheduleExceptionRequest'] == null) {
            throw new runtime.RequiredError(
                'scheduleExceptionRequest',
                'Required parameter "scheduleExceptionRequest" was null or undefined when calling applyException().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/v1/schedules/{scheduleId}/blocks/exceptions`;
        urlPath = urlPath.replace(`{${"scheduleId"}}`, encodeURIComponent(String(requestParameters['scheduleId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ScheduleExceptionRequestToJSON(requestParameters['scheduleExceptionRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Applies an exception to schedule blocks (cancel, modify, extend, etc.)
     * Apply schedule exception
     */
    async applyException(requestParameters: ApplyExceptionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }> {
        const response = await this.applyExceptionRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieves schedule blocks for a time range
     * Get schedule blocks
     */
    async getBlocksRaw(requestParameters: GetBlocksRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>> {
        if (requestParameters['scheduleId'] == null) {
            throw new runtime.RequiredError(
                'scheduleId',
                'Required parameter "scheduleId" was null or undefined when calling getBlocks().'
            );
        }

        if (requestParameters['startTime'] == null) {
            throw new runtime.RequiredError(
                'startTime',
                'Required parameter "startTime" was null or undefined when calling getBlocks().'
            );
        }

        if (requestParameters['endTime'] == null) {
            throw new runtime.RequiredError(
                'endTime',
                'Required parameter "endTime" was null or undefined when calling getBlocks().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['startTime'] != null) {
            queryParameters['startTime'] = requestParameters['startTime'];
        }

        if (requestParameters['endTime'] != null) {
            queryParameters['endTime'] = requestParameters['endTime'];
        }

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['pageSize'] = requestParameters['pageSize'];
        }

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/schedules/{scheduleId}/blocks`;
        urlPath = urlPath.replace(`{${"scheduleId"}}`, encodeURIComponent(String(requestParameters['scheduleId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Retrieves schedule blocks for a time range
     * Get schedule blocks
     */
    async getBlocks(requestParameters: GetBlocksRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }> {
        const response = await this.getBlocksRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Gets the currently active block for a schedule
     * Get current block
     */
    async getCurrentBlockRaw(requestParameters: GetCurrentBlockRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>> {
        if (requestParameters['scheduleId'] == null) {
            throw new runtime.RequiredError(
                'scheduleId',
                'Required parameter "scheduleId" was null or undefined when calling getCurrentBlock().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/schedules/{scheduleId}/blocks/current`;
        urlPath = urlPath.replace(`{${"scheduleId"}}`, encodeURIComponent(String(requestParameters['scheduleId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Gets the currently active block for a schedule
     * Get current block
     */
    async getCurrentBlock(requestParameters: GetCurrentBlockRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }> {
        const response = await this.getCurrentBlockRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Gets the next upcoming block for a schedule
     * Get next block
     */
    async getNextBlockRaw(requestParameters: GetNextBlockRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>> {
        if (requestParameters['scheduleId'] == null) {
            throw new runtime.RequiredError(
                'scheduleId',
                'Required parameter "scheduleId" was null or undefined when calling getNextBlock().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/schedules/{scheduleId}/blocks/next`;
        urlPath = urlPath.replace(`{${"scheduleId"}}`, encodeURIComponent(String(requestParameters['scheduleId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Gets the next upcoming block for a schedule
     * Get next block
     */
    async getNextBlock(requestParameters: GetNextBlockRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }> {
        const response = await this.getNextBlockRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
